import { render, staticRenderFns } from "./secondsecond.vue?vue&type=template&id=29f7cf58&"
import script from "./secondsecond.vue?vue&type=script&lang=js&"
export * from "./secondsecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f7cf58')) {
      api.createRecord('29f7cf58', component.options)
    } else {
      api.reload('29f7cf58', component.options)
    }
    module.hot.accept("./secondsecond.vue?vue&type=template&id=29f7cf58&", function () {
      api.rerender('29f7cf58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/second/secondsecond.vue"
export default component.exports